
import schemas from "../data/dataSchemas";
import { geoPath, geoIdentity } from 'd3-geo';
import {propertyStatusColor} from "../data/PropertyStatusColor";

function createUnknownOwner(vindrId, key){

	return 	{
		...schemas.unknownOwner,
		...{
			properties:[{
					id:vindrId,
					totalArea:0,
					areaPercentage:0,
					name:'',
					area:0,
					vindrid:vindrId,
					status:'Not contacted'
			}],
			number:key+1,
			id:'temp_'+key
		}
	};
}
function filenamify(s){
	return s.replace(/[^a-z0-9]/gi, '_').toLowerCase();
}
function formatArea(area, user){ //gets area in m2


	if(user && user.settings && user.settings.areaUnit && user.settings.areaUnit == 'hectare')
		return (parseInt(area)/10000 /* m2 to ha */).toFixed(2).toLocaleString()+' ha';

	if(parseInt(area) > 99999)
		return (parseInt(area)/1000000 /* m2 to km2 */).toFixed(2).toLocaleString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")+' km²';
	else
		return parseInt(area).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")+' m²'


}
function formatAreaFromKm(area, user){ //gets area in m2


	if(user && user.settings && user.settings.areaUnit && user.settings.areaUnit == 'hectare')
		return (parseFloat(area)*100 /* m2 to ha */).toFixed(2).toLocaleString()+' ha';

	return area.toFixed(2).toLocaleString()+' km²';


}
function formatCurrency(amount, country){

	var currencySymbol = country && (country.toLowerCase() == 'sweden') ? 'kr' : process.env.REACT_APP_CURRENCY_SYMBOL;

	if(!amount)
		return currencySymbol+' 0'

	return currencySymbol+" "+ (new Intl.NumberFormat("fr", {
        maximumFractionDigits: 0,
        useGrouping: true
      }).format(parseFloat(amount)))

}
function formatDate(date, format){
	
	if(!date)
		return '';

	var d = Date.parse(date);

	if(d == 'NaN')
		return '0000-00-00 00:00:00';

	d = new Date(d);
	if(!format || format == "full")
		return d.getFullYear()+'-'+('0' + (d.getMonth()+1)).slice(-2)+'-'+('0' + d.getDate()).slice(-2)+' '+('0' + d.getHours()).slice(-2)+':'+('0' + d.getMinutes()).slice(-2);
	if(format == "short")
		return d.getFullYear()+'-'+('0' + (d.getMonth()+1)).slice(-2)+'-'+('0' + d.getDate()).slice(-2);
	if(format == "time")
		return ('0' + d.getHours()).slice(-2)+':'+('0' + d.getMinutes()).slice(-2);
	if(format == "natural")
		return d.toLocaleDateString('gb-GB' , {
										weekday: 'long',
										year: 'numeric',
										month: 'long',
										day: 'numeric',
									  });
	if(format == "naturalshort")
		return d.toLocaleDateString('en-US' , {
										month: 'short',
										day: 'numeric',
										year: 'numeric',
									  });
	if(format == "naturalshort-eu")
		return d.toLocaleDateString('en-GB', {
			weekday: 'short',
			day: 'numeric',
			month: 'short',
			year: 'numeric'
		});
	if(format == "dotted-full")
		return ('0' + d.getDate()).slice(-2)+'.'+('0' + (d.getMonth()+1)).slice(-2)+'.'+d.getFullYear()+' '+('0' + d.getHours()).slice(-2)+':'+('0' + d.getMinutes()).slice(-2);


}
function formatDistance(dist, precision){ //gets area in m2

	if(parseInt(dist) > 999)
		return (parseInt(dist)/1000 /* m to km */).toFixed(precision ?? 1)+' km';
	else
		return parseInt(dist)+' m'


}
function formatWindSpeed(speed){

	return parseFloat(speed).toFixed(1)+' m/s';
}
function format_power(mwh){

	if(!mwh)
		return false;

	var mw = parseFloat(mwh);

	if(mw<1000)
		return mw.toFixed(2)+" MWh";
	if(mw<1000000)
		return (mw/1000).toFixed(2)+" GWh";
	if(mw<1000000000)
		return (mw/1000000).toFixed(2)+" TWh";

}
function generateId(){
	return 'temp_'+Math.random().toString(36).substr(2, 9);
}
function tempId(){
	return Math.floor(1000000 + Math.random() * 10000000);
}
function isLand(p) {

	if(!p || !p.properties || !p.properties.vindrid || p.properties.vindrid == '')
		return false;

	const seRegex = /^[\p{L}\d\-\s\(\)\/&]+?\s+\d+:\d+(?:>\d+)*$/u;
	const noRegex = /^[0-9]{4}-[0-9]{1,4}\/[0-9]{1,4}(?:\/[0-9]{1,4}){0,2}$/;
	const eeRegex = /^[0-9]{3,5}:[0-9]{1,4}:[0-9]{1,4}$/;
	const lvRegex = /^[0-9]{11}$/;

	return (seRegex.test(p.properties.vindrid) || noRegex.test(p.properties.vindrid) || eeRegex.test(p.properties.vindrid) || lvRegex.test(p.properties.vindrid));

}
function isNumeric(str){
	return Number.isInteger(parseInt(str));
}
function multiLine2Line(f){
	if(f.geometry && f.geometry.type == "MultiLineString"){
		f.geometry.type = "LineString"

		if(f.geometry.coordinates[0])
			f.geometry.coordinates = f.geometry.coordinates[0];
		else
			f.geometry.coordinates = [];
	}
	return f;
}
function rads2deg(radians)
{
  var pi = Math.PI;
  return radians * (180/pi);
}
function randomColor(){
	return '#' + Math.floor(Math.random() * 0xFFFFFF).toString(16).padStart(6, '0');
}
function randomId(){
	return Math.random().toString(36).substr(2, 9);
}
function removePropertyFromOwner(owner, pId){

	if(owner && pId){

		var ow = JSON.parse(JSON.stringify(owner));

		var idx = -1;
		while((idx = ow.properties.findIndex((p)=>p.id == pId))>-1){
			ow.properties.splice(idx,1);
		}
		return ow;
	}
	return false;
}
function setUrlParam(param, value){

	const url = new URL(window.location.origin+window.location.pathname+window.location.search);

	if(value)
		url.searchParams.set(param, value);
	else
		url.searchParams.delete(param);

	window.history.pushState({ goBack: true }, "", url);
}
function smartParseDate(dateStr) {
  if (!dateStr) return null;

  // Already ISO-like? let JS parse it
  if (!dateStr.includes("/") && !dateStr.match(/^\d{2}-\d{2}-\d{4}/)) {
    const d = new Date(dateStr);
    return isNaN(d) ? null : d;
  }

  // Convert DD/MM/YYYY (or DD-MM-YYYY) to YYYY-MM-DD
  const cleaned = dateStr.replace(/-/g, "/");
  const parts = cleaned.split("/");

  if (parts.length < 3) return null;

  // Supports "DD/MM/YYYY HH:mm:ss"
  const [day, month, yearAndTime] = parts;
  const [year, time] = yearAndTime.split(" ");

  const iso = `${year}-${month}-${day}` + (time ? ` ${time}` : "");
  const d = new Date(iso);

  return isNaN(d) ? null : d;
}
function sortByDate2(arr, key, direction = "asc") {
  return arr.sort((a, b) => {
    const dateA = smartParseDate(a[key]);
    const dateB = smartParseDate(b[key]);

    // Nulls always go to the end
    if (!dateA && !dateB) return 0;
    if (!dateA) return 1;
    if (!dateB) return -1;

    return direction === "asc"
      ? dateA - dateB
      : dateB - dateA;
  });
}
function isObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}	
function timeAgo(date) {

	if(!date)
		return '';

    const now = new Date();
    const then = new Date(date);

    const seconds = Math.floor((now - then) / 1000);

    const intervals = {
        year:   365 * 24 * 60 * 60,
        month:  30 * 24 * 60 * 60,
        day:    24 * 60 * 60,
        hour:   60 * 60,
        minute: 60,
        second: 1
    };

    for (let key in intervals) {
        const value = intervals[key];
        if (seconds >= value) {
            const count = Math.floor(seconds / value);
            return `${count} ${key}${count > 1 ? "s" : ""} ago`;
        }
    }

    return "just now";
}
function updateGeojsonOwner(g, pId, oId){
	if(g){
		var idx = g.features.findIndex((p)=>p.properties.id == pId);
		if(idx>-1){
			g.features[idx].properties.ownerid = [oId];
		}
	}
}
function updateGeojsonOwnerColor(g, data){
	if(g){

		g.features.forEach((p)=>{
			if(p.properties.ownerid.includes(data.id))
				p.properties.color = data.color;
		});
	}
}
function userAddRecent(u, projectId){ //

	if(u && u.settings && u.settings.recentProjects){

		// check if already exists and removes it
		var idx = u.settings.recentProjects.findIndex((rp)=>{
			if((typeof rp === "object" || typeof rp === 'function') && (rp !== null)){
				return rp.projectId == projectId;
			}
			else{
				return rp == projectId;
			}
		})
		if(idx != -1)
			u.settings.recentProjects.splice(idx, 1);


		u.settings.recentProjects.unshift({"projectId": projectId, "lastOpened": (new Date().toISOString())});
		u.settings.recentProjects.splice(3, 5);
		u.email = u.userDetails;

	}
}
function validity(errors, touched, field){

	if(!errors[field] && touched[field])
		return 'is-valid';
	if(errors[field] && touched[field])
		return 'is-invalid';
}

const sortByDate = (rowA, rowB, selector) => {
  const dateA = new Date(selector(rowA));
  const dateB = new Date(selector(rowB));

  return dateA - dateB;
};

const norm = (item) => {
	return item.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
};
const sortStrings = (
	a,
	b,
	{ nullsLast = true, caseInsensitive = true } = {}
) => {
	if (a == null && b == null) return 0;
	if (a == null) return nullsLast ? 1 : -1;
	if (b == null) return nullsLast ? -1 : 1;

	let strA = String(a);
	let strB = String(b);

	if (caseInsensitive) {
		strA = strA.toLowerCase();
		strB = strB.toLowerCase();
	}

	return strA.localeCompare(strB);
};

const naturalSort = (a, b, selector) => {
	const ax = [];
	const bx = [];

	String(selector(a) ?? "").replace(/(\d+)|(\D+)/g, (_, $1, $2) => {
		ax.push([$1 || Infinity, $2 || ""]);
	});

	String(selector(b) ?? "").replace(/(\d+)|(\D+)/g, (_, $1, $2) => {
		bx.push([$1 || Infinity, $2 || ""]);
	});

	while (ax.length && bx.length) {
		const [an, as] = ax.shift();
		const [bn, bs] = bx.shift();

		if (as !== bs) {
			return as.localeCompare(bs, undefined, { sensitivity: "base" });
		}

		if (an !== bn) {
			return Number(an) - Number(bn);
		}
	}

	return ax.length - bx.length;
}
const parseMeters = (str) => {
	if(str === null || str === undefined || str === '')
		return null;
	const match = String(str).trim().match(/^([\d.,]+)\s*(km|m)?$/i);
	if(!match)
		return null;
	const num = parseFloat(match[1].replace(',', '.'));
	const unit = (match[2] || 'm').toLowerCase();
	return Math.round(unit === 'km' ? num * 1000 : num);
}
const randomNumber = () =>{
	return Math.floor(1000000 + Math.random() * 10000000);
}
const translateGeo = (geo, offset) => {
	
	function translateGroup(group){
		group.forEach((c)=>{

			c[0] += offset[0];
			c[1] += offset[1];
		});
		
	}
	
	
	if(geo.type == "MultiPolygon"){
		geo.coordinates[0].forEach((g)=>{
			translateGroup(g);
		});
	}
	else if(geo.type == "LineString"){
		translateGroup(geo.coordinates);
	}
	else if(geo.type == "MultiLineString"){
		geo.coordinates.forEach((g)=>{
			translateGroup(g);
		});
	}
	else {
		// Polygon
		translateGroup(geo.coordinates[0]);
	}
	
}
function geojsonToPath(geojson, size = 24) {
	const projection = geoIdentity()
		.reflectY(true)
		.fitSize([size, size], geojson);

	const pathGenerator = geoPath(projection);
	return pathGenerator(geojson);
}

function GeoJsonIcon({ geojson, size = 24, color = 'black' }) {
	const path = geojsonToPath(geojson, size);

	return (
		<svg
			className="shapeicon"
			width={size}
			height={size}
			viewBox={`0 0 ${size} ${size}`}
		>
			<path d={path} fill={color} />
		</svg>
	);
}
const normalizeOwner = (o) => {
	o.fullName = o.companyName ? o.companyName : o.firstName+' '+o.lastName;
	o.type = o.companyName ? 'company' : 'private';
}

function processOwnersAndLands(ownersList, geodata) {

	var statusList = propertyStatusColor.getList();

	geodata.features.sort((a,b)=>{
		return (!!a.properties.ownerid.length === !!b.properties.ownerid.length) ? 0 : !!a.properties.ownerid.length ? -1 : 1;;
	}).map((m,idx)=>{m.id = idx+1});
	ownersList.map((o, idx)=>{
		if(o.id == -1){
			o.fullName="(unknown)";
		}
	});
	if(Array.isArray(ownersList))
		geodata.features.map((i, key)=>{

			var id = false;
			var oKey = ownersList.length;

			ownersList.map((o, idx)=>{
				if(o.properties){
					var found = o.properties.find((prop)=>prop.id == i.properties.vindrid);
					if(found){
						o.color = i.properties.color;
						o.number = idx+1;
						i.properties.description = ((i.properties.description) ? (i.properties.description + ", " + o.number) : o.number);
						id = o.id;
					}
				}
			});

			i.properties.statusDescription = statusList.findIndex((item)=>{return item == i.properties.status})+1;
			i.ownerid = id;

			if(!i.properties.ownerid.length && !id && isLand(i)){
				ownersList.push(createUnknownOwner(i.properties.vindrid, oKey));
				i.properties.description = ownersList.length;
				i.properties.ownerid = ['temp_'+oKey];
			}
			if(!i.properties.ownerid.length && id){
				i.properties.ownerid = [id];
			}

			return i;
		});
	ownersList.sort((a,b)=>{return a.number-b.number});
}

function number_format(number, decimals = 0, dec_point = '.', thousands_sep = ' ') {
	const fixed = parseFloat(number).toFixed(decimals);
	const [intPart, decPart] = fixed.split('.');
	const intFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands_sep);
	return decPart !== undefined ? intFormatted + dec_point + decPart : intFormatted;
}

function updateGeoJsonLayer(map, data){
	if(map && map.getSource('project-geojson')){
		map.getSource('project-geojson').setData(data);
	}
}

export {
	createUnknownOwner,
	filenamify,
	formatArea,
	formatAreaFromKm,
	formatCurrency,
	formatDate,
	formatDistance,
	formatWindSpeed,
	format_power,
	generateId,
	isLand,
	isNumeric,
	isObject,
	multiLine2Line,
	naturalSort,
	norm,
	rads2deg,
	randomColor,
	randomId,
	removePropertyFromOwner,
	setUrlParam,
	smartParseDate,
	sortByDate,
	sortByDate2,
	sortStrings,
	timeAgo,
	updateGeojsonOwner,
	updateGeojsonOwnerColor,
	userAddRecent,
	validity,
	tempId,
	randomNumber,
	parseMeters,
	translateGeo,
	geojsonToPath,
	GeoJsonIcon,
	normalizeOwner,
	number_format,
	processOwnersAndLands,
	updateGeoJsonLayer
};
